import React, { Component } from "react";
//// componentes reutilizables
import TecladoPin from "../../../generico/TecladoPin";
import NumberFormat from "react-number-format";
import md5 from "md5";
import Popup from "react-popup";
import { trackPromise } from "react-promise-tracker";
import AuthService from "../../../../services/login/auth.service";
import MensajeUsuario from "../../../generico/MensajeUsuario";
import TransferQrService from "../../../../services/transferencias/TransferQrService";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";

//TransferenciaQrEnviarPaso3
export default class TransferenciaQrEnviarPaso3 extends Component {
  COD_PAGO_CUENTA_AHORRO = 'CCAHOO';
  COD_PARTICIPANTE = '1607';

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }
  getInitialState = () => ({
    pin: "",
    nroOperacion: 0,
    disableSgte: true,
    nombreSocio: undefined,
    cedulaSocio: undefined,
    nroSocio: undefined
  });
  resetState = () => {
    this.setState(this.getInitialState());
  };

  componentDidMount() {
    let usuario = AuthService.getCurrentUser();

    this.setState({
      nombreSocio: usuario.nombreCompleto,
      cedulaSocio: usuario.cedulaIdentidad,
      nroSocio: usuario.numeroSocio
    })
  }

  notifiPopup = (titulo, mensaje) =>
    
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  pinValue = (value) => {
    this.setState({
      pin: value,
    });
    this.enableNext(value);
  };

  enableNext(pin) {
    if (pin !== "" && pin.length === 6) {
      this.state.disableSgte = false;
    } else {
      this.state.disableSgte = true;
    }
  }


  confirmar = (e) => {
    //// bloquea boton
    this.btn.setAttribute("disabled", "disabled");
    var importe = this.props.importe.split('.').join('');
    importe = String(importe).replace(/\,/g, ".");


    let data = JSON.stringify({
      canalOrigen         : "CU24HS_WEB",
      ciOriginante        : this.state.cedulaSocio,
      idClienteEF         : this.state.nroSocio,
      codOriginante       : this.COD_PARTICIPANTE,
      titularOriginante   : this.state.nombreSocio,
      numCuentaOrigen     : this.props.cuentaOrigen.ahorro,
      tipoCuentaOrigen    : this.COD_PAGO_CUENTA_AHORRO,
      codDestinatario     : this.props.datosTransfQR.codDestinatario,
      docDestinatario     : this.props.datosTransfQR.docDestinatario,
      titularDestinatario : this.props.datosTransfQR.titularDestinatario,
      numCuentaDestino    : this.props.datosTransfQR.numCuentaDestino,
      tipoCuentaDestino   : this.props.datosTransfQR.tipoCuentaDestino,
      importe             : importe,
      idQr                : this.props.datosTransfQR.idQr,
      motivoOperacion     : this.props.motivo,
      pinTransaccional    : md5(this.state.pin)
    });

    trackPromise(
      TransferQrService.confirmarTransferencia(data)
        .then((response) => {
          //// Habilita boton
          this.btn.removeAttribute("disabled");
          var data = JSON.stringify(response.data);
          var jData = JSON.parse(data);

          if(jData !== undefined && jData !== null){
            if (jData.codigoRetorno === "0") {
              let numeroOperacion = jData.datos.idTxOriginante;
              this.props.returnDataPaso3(numeroOperacion, this.props.importe);
              this.nextStep.click();
            }else{
              Popup.queue(this.notifiPopup("Error", jData.mensajeRetorno));
            }
          } else {
            Popup.queue(this.notifiPopup("Error", "Tiempo de espera agotado. Verifique si se realizó el débito de su cuenta o intente más tarde."));
          }
        })
    ).catch(function (error) {
      console.log(error)
      Popup.queue(Popup.register({
        title: "Error Inesperado.",
        content: "Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste.",
        buttons: {
          right: [
            {
              text: "Aceptar",
              className: "success",
              action: function () {
                Popup.close();
              },
            },
          ],
        },
      }));
    });
  };

  render() {
    return (
      <div>
        <form id="idFormPaso3" onSubmit={(e) => e.preventDefault()}>
          <div className="row">
            <div className="steps clearfix">
              <ul role="tablist">
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text current">
                        Leer código QR
                      </span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text">Datos de Transferencia</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="current">
                  <span>
                    <div className="title">
                      <span className="title_text">Datos de Verificación</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled last">
                  <span>
                    <div className="title">
                      <span className="title_text">Confirmación</span>
                    </div>
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-8" style={{ marginBottom: 5 }}>
                  <h6 style={{ margin: 0 }}>
                    Cuenta: {this.props.cuentaOrigen.ahorro} -{" "}
                    {AuthService.getSocio().nombreCompleto.trim()}
                  </h6>
                  <p style={{ marginBottom: 0 }}>
                    Tipo: {this.props.cuentaOrigen.descripcion}
                  </p>
                  <p>Moneda: {this.props.cuentaOrigen.moneda}</p>
                </div>
              </div>
              <div className="row invoice-info">
                <div className="col-12">
                  <div className="table-responsive">
                    {this.props.cuen}
                    <table className="table">
                      <tbody>
                        <tr>
                          <th>Cuenta Crédito:</th>
                          <td>{this.props.datosTransfQR.numCuentaDestino}</td>
                        </tr>
                        <tr>
                          <th>Importe del Crédito:</th>
                          <td>
                            <NumberFormat
                              value={this.props.importe}
                              displayType={"text"}
                              decimalSeparator={","}
                              thousandSeparator={"."}
                            />{" "}
                            {this.props.cuentaOrigen.moneda}.
                          </td>
                        </tr>
                        <tr>
                          <th>Titular de la cuenta destino:</th>
                          <td>{this.props.datosTransfQR.titularDestinatario}</td>
                        </tr>
                        {/* <tr>
                          <th>Tipo documento de la cuenta destino:</th>
                          <td>{this.props.datosTransfQR.tipoDocDestino}</td>
                        </tr> */}
                        <tr>
                          <th>Documento de la cuenta destino:</th>
                          <td>{this.props.datosTransfQR.docDestinatario}</td>
                        </tr>
                        <tr>
                          <th>Motivo:</th>
                          <td>{this.props.motivo}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
                <div className="invoice p-3 mb-3 teclados">
                  <TecladoPin
                    pinValue={this.pinValue.bind(this)}
                    label="Ingrese el Pin de Transacción"
                  />
                </div>
            </div>
          </div>
                <div className="col-12">
                  <MensajeUsuario tipo="INFO"
                    titulo="Importante!"
                    mensaje="El límite diario es de 6.000.000 Gs. (establecido por Bancard)." />
                </div>
          <hr />
          <div className="row">
            <div className="col-lg-6 col-md-6"></div>
            <div className="col-lg-3 col-md-3">
            <button
              className="btn btn-cu-quintary btn-consulta"
              onClick={this.props.previousStep}
            >
            <FontAwesomeIcon icon={faArrowLeft} />  Volver
            </button>
            </div>
            <div className="col-lg-3 col-md-3">
            <button ref={btn => { this.btn = btn; }}
              className="btn btn-cu-primary"
              disabled={this.state.disableSgte}
              onClick={this.confirmar}
            >
              Confirmar Transferencia <FontAwesomeIcon icon={faArrowRight} />
            </button>
            <button
              hidden
              ref={(a) => (this.nextStep = a)}
              className="btn btn-cu-primary"
              onClick={this.props.nextStep}
            ></button>
            </div>
           
          
          </div>
        </form>
      </div>
    );
  }
}
